var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    [
      _c(
        "v-card-text",
        [
          _c(
            "div",
            {
              staticStyle: {
                border: "2px dashed #373535 !important",
                "border-radius": "0.5em",
              },
            },
            [
              _c("file-pond", {
                ref: "pond",
                attrs: {
                  name: "audiofile",
                  "label-idle": "Drop files here, or click to browse.",
                  "allow-multiple": true,
                  "accepted-file-types": "audio/*",
                  server: _vm.app.ajaxurl + "?action=dialer_upload_audio_file",
                  files: _vm.files,
                },
                on: {
                  init: _vm.handleFilePondInit,
                  processfiles: _vm.processFiles,
                },
              }),
            ],
            1
          ),
          _c("v-data-table", {
            staticClass: "elevation-1 mt-4",
            staticStyle: { border: "none" },
            attrs: {
              headers: _vm.headers,
              items: _vm.user.audio_files,
              "items-per-page": 5,
              loading: _vm.user.audio_files_loading,
              "loading-text": "Loading...",
              "single-select": false,
              "item-key": "sid",
              "hide-default-footer": _vm.user.audio_files.length <= 5,
            },
            scopedSlots: _vm._u([
              {
                key: "item.filename",
                fn: function ({ item }) {
                  return [
                    _c("a", { attrs: { href: item.url, target: "_blank" } }, [
                      _vm._v(_vm._s(item.filename)),
                    ]),
                  ]
                },
              },
              {
                key: "item.player",
                fn: function ({ item }) {
                  return [
                    _c("audio-player", {
                      attrs: {
                        url: item.url,
                        playerid: "audio-player",
                        expanded: true,
                      },
                    }),
                  ]
                },
              },
              {
                key: "item.actions",
                fn: function ({ item }) {
                  return [
                    _c(
                      "v-btn",
                      {
                        attrs: { icon: "" },
                        on: {
                          click: function ($event) {
                            return _vm.confirmDeleteAudioFile(item)
                          },
                        },
                      },
                      [_c("v-icon", [_vm._v("mdi-delete")])],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { width: "60%", "max-width": "500" },
          model: {
            value: _vm.show_confirm_delete_dialog,
            callback: function ($$v) {
              _vm.show_confirm_delete_dialog = $$v
            },
            expression: "show_confirm_delete_dialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "text-h5" }, [
                _vm._v(" Delete Audio File? "),
              ]),
              _c("v-card-text", [
                _vm._v(" Are you sure you want to delete "),
                _c("strong", [_vm._v(_vm._s(_vm.delete_file.filename))]),
                _vm._v("? "),
              ]),
              _c("v-divider"),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary", text: "" },
                      on: {
                        click: function ($event) {
                          _vm.show_confirm_delete_dialog = false
                        },
                      },
                    },
                    [_vm._v(" Cancel ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "red",
                        loading: _vm.user.audio_files_loading,
                        disabled: _vm.user.audio_files_loading,
                      },
                      on: {
                        click: function ($event) {
                          _vm.user.deleteAudioFile(_vm.delete_file)
                          _vm.show_confirm_delete_dialog = false
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("mdi-dlete")]), _vm._v(" Delete ")],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }